import { type QuestionPropsBase } from "features/Library/Common/QuestionsForm/types";
import { TextQuestion } from "features/Library/Common/QuestionsForm/Questions/QuestionFields/TextQuestion/TextQuestion";

export type TextQuestionProps = QuestionPropsBase<string>;

export const SurveyTextQuestion = (props: TextQuestionProps) => {
  const { question, propertyNamePrefix, ...restProps } = props;
  const propertyName = `${propertyNamePrefix}question`;

  return <TextQuestion question={question} propertyName={propertyName} {...restProps} />;
};
